"use client"

import { Tractor } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `TractorIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const TractorIcon = component(Icon)({ as: Tractor })
